import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./routes/home/resultcardcontainer.js